// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type CurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string, name?: string | null, avatar?: Types.UserAvatar | null, username: string, preferredLanguage?: Types.UserPreferredLanguage | null, workspaceId: string, isPersonalWorkspace: boolean, workspace?: { __typename?: 'Workspace', id: string, name: string, ownerId: string, permissionsVersion: number, customThemeTokens?: { __typename?: 'WorkspaceThemeTokens', light: { __typename?: 'WorkspaceThemeTokenVariant', background: string, foreground: string, card: string, cardForeground: string, primary: string, primaryForeground: string, accent: string, accentForeground: string, border: string, ring: string, sidebar: string, sidebarForeground: string, sidebarPrimary: string, sidebarPrimaryForeground: string, sidebarAccent: string, sidebarAccentForeground: string }, dark: { __typename?: 'WorkspaceThemeTokenVariant', background: string, foreground: string, card: string, cardForeground: string, primary: string, primaryForeground: string, accent: string, accentForeground: string, border: string, ring: string, sidebar: string, sidebarForeground: string, sidebarPrimary: string, sidebarPrimaryForeground: string, sidebarAccent: string, sidebarAccentForeground: string } } | null, permissions: Array<{ __typename?: 'WorkspacePermission', action: Types.Action, effect: Types.PermissionEffect, resourceKey?: string | null, subject: Types.Subject }> } | null, availableWorkspaces: Array<{ __typename?: 'Workspace', id: string, name: string, ownerId: string, organizationId?: string | null, organizationName?: string | null, workspaceRole?: string | null, isReadOnly?: boolean | null, isPersonalWorkspace: boolean }>, limits: { __typename?: 'UserLimits', maxWorkspaces: number, invitesLimit: number, maxCollectionFields: number } } };


export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    email
    name
    avatar
    username
    preferredLanguage
    workspaceId
    isPersonalWorkspace
    workspace {
      id
      name
      ownerId
      permissionsVersion
      customThemeTokens {
        light {
          background
          foreground
          card
          cardForeground
          primary
          primaryForeground
          accent
          accentForeground
          border
          ring
          sidebar
          sidebarForeground
          sidebarPrimary
          sidebarPrimaryForeground
          sidebarAccent
          sidebarAccentForeground
        }
        dark {
          background
          foreground
          card
          cardForeground
          primary
          primaryForeground
          accent
          accentForeground
          border
          ring
          sidebar
          sidebarForeground
          sidebarPrimary
          sidebarPrimaryForeground
          sidebarAccent
          sidebarAccentForeground
        }
      }
      permissions {
        action
        effect
        resourceKey
        subject
      }
    }
    availableWorkspaces {
      id
      name
      ownerId
      organizationId
      organizationName
      workspaceRole
      isReadOnly
      isPersonalWorkspace
    }
    limits {
      maxWorkspaces
      invitesLimit
      maxCollectionFields
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
// @ts-ignore
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = ApolloReactCommon.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;